import { useCallback } from "react"

import toast from "react-hot-toast"
import uuid from "uuid"

import MultiImageChooser from "components/lib/Choosers/MultiImageChooser"

const MultiImage = ({ field, fieldValue: images = [], ideaId, isEditing, updateIdea }) => {
  const addImages = useCallback(
    (
      files: {
        savedName: string
        fileName: string
        signedDownloadRequest: string
      }[],
    ) => {
      if (field.maxFiles && images.length + files.length > field.maxFiles) {
        toast.error("Your uploads exceed the maximum number of files allowed")
        return
      }

      const updatedImages = [
        ...files.map((file) => ({
          value: file.signedDownloadRequest,
          name: file.fileName,
          _id: uuid.v4(),
        })),
        ...images,
      ]
      updateIdea(updatedImages, ["templated", field.id])
    },
    [field.id, field.maxFiles, images, updateIdea],
  )

  const removeImage = useCallback(
    (_id) => {
      const updatedImages = images.filter((i) => i._id !== _id)
      updateIdea(updatedImages, ["templated", field.id])
    },
    [images, field, updateIdea],
  )

  const maxImages = field.maxImages || 10
  // const disableUpload = field.maxImages ? images.length >= maxImages : null

  return (
    <MultiImageChooser
      editing={isEditing}
      onComplete={addImages}
      deleteFile={removeImage}
      forType="idea"
      forId={ideaId}
      getFileUrl={(image) => image.value}
      images={images}
      maxImages={maxImages}
    />
  )
}

export default MultiImage
